export default __webpack_public_path__ + "static/media/personality-test-green.5861f9a3.png";